import React from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native-web';

import Image from '../../../shared/Image';
import Button from '../../../ui/Button';
import BodyText from '../../../ui/BodyText';
import HeaderText from '../../../ui/HeaderText';

import './Slide.module.scss';

import fourtyPercent from '../../../../../images/icons/40percent.svg';
import lock from '../../../../../images/icons/lock.svg';
import list from '../../../../../images/icons/list.svg';

export default function ClientsLoveItSlide({ showPaymentsButton }) {
  return (
    <View styleName="slide">
      <HeaderText styleName="slide__header" level="1">Clients Love It</HeaderText>
      <View>
        <Image source={fourtyPercent} styleName="slide__icon slide__icon--fourty-percent" />
        <BodyText styleName="slide__copy">
          Clients tip an average of 40% more when they pay through StyleSeat.
        </BodyText>
      </View>
      <View>
        <Image source={lock} styleName="slide__icon slide__icon--lock" />
        <BodyText styleName="slide__copy">
          You can securely store their credit cards on file for a seamless checkout experience.
        </BodyText>
      </View>
      <View>
        <Image source={list} styleName="slide__icon" />
        <BodyText styleName="slide__copy">
          Itemized receipts are sent automatically
          &#8209;&#8209;&nbsp;that&apos;s one less thing to worry about.
        </BodyText>
      </View>
      { showPaymentsButton && (
        <Button
          size="medium"
          text="Get Started"
          link="provider.settings_menu.payments"
          linkParams={{ clickSource: 'growth_tab_swiper' }}
        />
      )}
    </View>
  );
}

ClientsLoveItSlide.propTypes = {
  /** boolean to show the payments setup button */
  showPaymentsButton: PropTypes.bool,
};

ClientsLoveItSlide.defaultProps = {
  showPaymentsButton: false,
};
